var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11924_8933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 45C35.6764 45 45.75 34.9264 45.75 22.5C45.75 10.0736 35.6764 0 23.25 0C10.8236 0 0.75 10.0736 0.75 22.5C0.75 34.9264 10.8236 45 23.25 45Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40097 8.80154C3.63357 11.101 2.30089 13.7514 1.5249 16.6306H13.23L5.40097 8.80154Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9745 16.6306C44.1985 13.7514 42.8657 11.1011 41.0984 8.80162L33.2695 16.6306H44.9745Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5249 28.3697C2.30098 31.2488 3.63366 33.8991 5.40097 36.1985L13.2297 28.3697H1.5249Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9481 4.65125C34.6486 2.88386 31.9983 1.55117 29.1191 0.775101V12.4801L36.9481 4.65125Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55127 40.3487C11.8508 42.1161 14.5011 43.4488 17.3802 44.2249V32.52L9.55127 40.3487Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3801 0.775101C14.501 1.55117 11.8507 2.88386 9.55127 4.65117L17.3801 12.48V0.775101Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1196 44.2249C31.9987 43.4488 34.6491 42.1161 36.9485 40.3488L29.1196 32.52V44.2249Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2695 28.3697L41.0984 36.1986C42.8657 33.8992 44.1985 31.2488 44.9745 28.3697H33.2695Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5595 19.5652H26.1849H26.1848V0.190459C25.2241 0.0653906 24.2447 0 23.25 0C22.2552 0 21.2759 0.0653906 20.3152 0.190459V19.5651V19.5652H0.940459C0.815391 20.5259 0.75 21.5053 0.75 22.5C0.75 23.4948 0.815391 24.4741 0.940459 25.4348H20.3151H20.3152V44.8095C21.2759 44.9346 22.2552 45 23.25 45C24.2447 45 25.2241 44.9347 26.1848 44.8095V25.4349V25.4348H45.5595C45.6846 24.4741 45.75 23.4948 45.75 22.5C45.75 21.5053 45.6846 20.5259 45.5595 19.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1196 28.3697L39.1599 38.41C39.6217 37.9484 40.0622 37.4657 40.4825 36.9655L31.8866 28.3696H29.1196V28.3697Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3802 28.3697H17.38L7.33984 38.4099C7.80145 38.8717 8.28405 39.3122 8.78433 39.7325L17.3802 31.1364V28.3697Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3804 16.6306V16.6304L7.34016 6.59004C6.87838 7.05164 6.43787 7.53425 6.01758 8.03452L14.6135 16.6305H17.3804V16.6306Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1196 16.6306L39.16 6.59013C38.6984 6.12835 38.2158 5.68784 37.7155 5.26764L29.1196 13.8636V16.6306Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11924_8933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b39b627a079bf10fc4a98fa69f591e27.svg";
export { ForwardRef as ReactComponent };